import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: '',
    isBanned:null,
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
  detail: {
    userNo:'',
    storeNo:'',
    isBlocked:true,
    memo:'',
    storeName:'',
    userName:'',
    orderCount:0,
    favProductCount:0,
    favStoreCount:0,
    orderManageNo:'',
    modifyDate:'',
    lastOrderDate:'',
    reviews:[],
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
